import { generateMutations } from '../builder'

export default {
  ...generateMutations('getAdaptationFormats', 'adaptationFormats'),
}
